import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export type BasketNavigationClickEventParams = {
	targetPage?: 'summary';
	label: string;
	targetUrl: string;
};

export class BasketNavigationClickEvent extends BaseEvent {
	constructor({ targetPage = 'summary', label, targetUrl }: BasketNavigationClickEventParams) {
		super({
			eventInfo: {
				eventAction: EventAction.InternalLink,
				eventName: `configurator (Basket) - go to ${targetPage} page`,
			},
			attributes: {
				label,
				elementName: 'Button',
				targetURL: targetUrl,
			},
			updatePageInfo: {
				page: {
					pageInfo: {
						referringURL: window && window.location ? window.location.href : '',
					},
				},
			},
		});
	}
}
